import clsx from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { borderRadius } from '../tokens';
import { skeleton } from './skeleton.css';

export const Skeleton = function Skeleton({
  ref,
  className,
  height = 12,
  width = 80,
  radius = borderRadius.r8,
  ...rest
}: ComponentPropsWithRef<'div'> & {
  height?: number | string;
  width?: number | string;
  radius?: number;
}) {
  return (
    <div
      ref={ref}
      style={{ height, width, borderRadius: radius }}
      className={clsx(className, skeleton)}
      {...rest}
    />
  );
};
